import {Dispatch} from "redux";
import {setMeAction} from "../../../app/setMe/actions";
import {ErrorDto, getErrorDtoFromApiError} from "../../../models/dtos/error.dto";
import {MeDto} from "../../../models/dtos/me.dto";
import {UserState} from "../../../models/enums/userState";
import {AnswerRequest} from "../../../models/requests/answer.request";
import {LocalStorage} from "../../../utilities/storage";
import {
  ANSWER_QUESTION_FAIL,
  ANSWER_QUESTION_RESET,
  ANSWER_QUESTION_START,
  ANSWER_QUESTION_SUCCESS,
} from "./constants";
import {answerQuestionRequest} from "./repository";
import {
  AnswerQuestionFailAction,
  AnswerQuestionResetAction,
  AnswerQuestionStartAction,
  AnswerQuestionSuccessAction,
} from "./types";

const answerQuestionStartAction = (): AnswerQuestionStartAction => {
  return {
    type: ANSWER_QUESTION_START,
  };
}
const answerQuestionSuccessAction = (payload: MeDto): AnswerQuestionSuccessAction => {
  return {
    type: ANSWER_QUESTION_SUCCESS,
    payload: payload,
  };
}
const answerQuestionFailAction = (error: ErrorDto): AnswerQuestionFailAction => {
  return {
    type: ANSWER_QUESTION_FAIL,
    error: error,
  };
}
const answerQuestionResetAction = (): AnswerQuestionResetAction => {
  return {
    type: ANSWER_QUESTION_RESET,
  };
}

export const answerQuestion = (request: AnswerRequest) => async (
  dispatch: Dispatch
) => {
  try {
    dispatch(answerQuestionStartAction());
    const response = await answerQuestionRequest(request);
    if (response.state === UserState.WINNER) {
      LocalStorage.set(LocalStorage.modalCongrats, "true");
    }
    dispatch(setMeAction(response));
    dispatch(answerQuestionSuccessAction(response));
  } catch (error) {
    dispatch(answerQuestionFailAction(getErrorDtoFromApiError(error)));
  }
};

export const answerQuestionReset = () => (
  dispatch: Dispatch
) => {
  dispatch(answerQuestionResetAction());
};
